<template>
  <div class="add-team">
    <Card>
      <h2 v-if="!teamInfo.id" style="text-align: center;margin:20px 0 0 0;">新增应急队伍</h2>
      <h2 v-else style="text-align: center;margin:20px 0 0 0;">修改应急队伍</h2>
      <Divider/>
      <div style="width: 70%;margin: 0 auto">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
          <FormItem label="队伍名称" prop="name">
            <Input v-model="formValidate.name" placeholder="请填写队伍名称"></Input>
          </FormItem>
          <FormItem label="负责单位" prop="responsibleUnitId">
            <TreeSelect v-model="formValidate.responsibleUnitId" placeholder="请选择单位" class="treeSelect" transfer
                        clearable :data="unitList"/>
          </FormItem>
          <FormItem label="值班电话" prop="dutyTelephone">
            <Input v-model="formValidate.dutyTelephone" placeholder="请填写负责单位电话"></Input>
          </FormItem>
          <FormItem label="队伍类型" prop="teamType">
            <Select v-model="formValidate.teamType" placeholder="请选择队伍类型">
              <Option :value="1">政府队伍</Option>
              <Option :value="2">企业队伍</Option>
              <Option :value="3">社会队伍</Option>
            </Select>
          </FormItem>
          <FormItem label="成立时间" prop="establishedTime">
            <DatePicker type="date" placeholder="请选择成立时间" v-model="formValidate.establishedTime"></DatePicker>
          </FormItem>
          <FormItem label="详细地址" prop="address">
            <Input v-model="formValidate.address" placeholder="请填写详细地址"></Input>
          </FormItem>
          <FormItem label="适用事件类型" prop="applicableEventTypes">
            <Select transfer v-model="formValidate.applicableEventTypes" placeholder="请选择适用事件类型">
              <Option v-for="(item, index) in eventList" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="负责人" prop="personInCharge">
            <Input v-model="formValidate.personInCharge" placeholder="请填写负责人"></Input>
          </FormItem>
          <FormItem label="负责人手机" prop="personInChargePhone">
            <Input v-model="formValidate.personInChargePhone" placeholder="请填写负责人手机"></Input>
          </FormItem>
          <FormItem label="人数" prop="countPeople">
            <Input v-model="formValidate.countPeople" placeholder="请填写人数"></Input>
          </FormItem>
          <FormItem label="负责单位行政区域" prop="responsibleAreaId">
            <Row :gutter="4">
              <Col :span="10">
                <FormItem>
                  <Select transfer clearable :disabled="countryList.length === 1" v-model="formValidate.responsibleAreaId" @on-change="getStreeByCountryId"
                          placeholder="区县">
                    <Option v-for="(item) in countryList" :key="item.id" :value="item.indexCode">{{ item.name }}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <!--              <Col :span="10">-->
              <!--                <FormItem prop="responsibleStreetId">-->
              <!--                  <Select transfer clearable v-model="formValidate.responsibleStreetId" placeholder="街道">-->
              <!--                    <Option v-for="(item) in streetList" :key="item.id" :value="item.id">{{ item.name }}</Option>-->
              <!--                  </Select>-->
              <!--                </FormItem>-->
              <!--              </Col>-->
            </Row>
          </FormItem>
          <FormItem label="经纬度" prop="longitude">
            <Row :gutter="4">
              <Col :span="3">
                <Button type="primary" @click="getLocationByMap">定位</Button>
              </Col>
              <!--              <Col :span="3">-->
              <!--                <Button type="primary" @click="getLocation">定位</Button>-->
              <!--              </Col>-->
              <Col :span="8">
                <FormItem prop="longitude">
                  <Input v-model="formValidate.longitude" placeholder="请填写经度"></Input>
                </FormItem>
              </Col>
              <Col :span="8">
                <FormItem prop="dimension">
                  <Input v-model="formValidate.dimension" placeholder="请填写纬度"></Input>
                </FormItem>
              </Col>
            </Row>
          </FormItem>
          <FormItem label="监管层级" prop="superviseLevel">
            <Select v-model="formValidate.superviseLevel" placeholder="请选择监管层级">
              <Option :value="1">市级</Option>
              <Option :value="2">区县级</Option>
              <Option :value="3">镇街级</Option>
            </Select>
          </FormItem>
          <FormItem label="队伍介绍" prop="introduce">
            <Input v-model="formValidate.introduce" type="textarea" :autosize="{minRows: 5}"/>
          </FormItem>
          <FormItem label="备注" prop="remarks">
            <Input v-model="formValidate.remarks" type="textarea" :autosize="{minRows: 5}"/>
          </FormItem>
          <FormItem label="附件" prop="annex">
            <!--            <Input v-model="formValidate.annex" type="textarea"/>-->
            <Upload
                :headers="annexHeaders"
                :show-upload-list="false"
                :on-success="annexSuccess"
                :action="$uploadUrl+'/api/file/upload'">
              <Button icon="ios-cloud-upload-outline">上传附件</Button>
            </Upload>
            <span v-if="formValidate.annex !== ''">
                          {{ formValidate.annex }}
                          <Icon type="md-close"
                                @click="delAnnexFilePath"
                                style="float: right;margin-right: 30px;line-height: 30px"/>
                        </span>
          </FormItem>
          <!--          <FormItem>-->
          <!--            <Button v-if="!teamInfo.id" type="primary" @click="handleSubmit('formValidate')">新增</Button>-->
          <!--            <Button v-if="teamInfo.id" type="primary" @click="editTeam('formValidate')">编辑</Button>-->
          <!--            <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>-->
          <!--          </FormItem>-->
        </Form>
        <div style="text-align: center">
          <Button v-if="!teamInfo.id" type="primary" :loading="saveLoading" @click="handleSubmit('formValidate')">新增
          </Button>
          <Button v-if="teamInfo.id" type="primary" :loading="saveLoading" @click="editTeam('formValidate')">编辑
          </Button>
          <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
          <Button @click="goBack" type="primary" style="margin-left: 8px">返回</Button>
        </div>
      </div>
    </Card>

    <Modal
        v-model="modal"
        title="地图"
        @on-ok="ok"
        @on-cancel="cancel">
      <div style="margin-bottom: 10px">
        <AutoComplete
            transfer
            clearable
            v-model="searchPlace"
            @on-search="handleSearch"
            placeholder="请输入搜索地址"
            style="width:400px">
          <Option v-for="item in searchList" :value="item.title" :key="item.uid">{{ item.title }}</Option>
        </AutoComplete>
        <Button type="primary" @click="getLocal">搜索</Button>
      </div>

      <div id="map" style="width: 100%;height: 400px"></div>
    </Modal>
  </div>
</template>

<script>
import { BMapLoader } from '@/utils/mapLoader'

export default {
  name: "addEmTeam",
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('必填'))
      } else if (!/^1[3456789]\d{9}$/.test(value)) { // 判断用户输入的值是否符合规则
        callback(new Error('请输入正确的11位手机号码'))
      } else {
        callback()
      }
    }
    return {
      saveLoading: false,
      annexHeaders: { Authorization: localStorage.getItem('token') },
      unitList: [],
      searchPlace: '',
      searchList: [],
      modal: false,
      eventList: [],
      teamInfo: {},
      streetList: [],
      countryList: [],
      formValidate: {
        name: '',
        responsibleUnitId: '',
        personInCharge: '',
        personInChargePhone: '',
        dutyTelephone: '',
        countPeople: '',
        teamType: 0, //1-政府队伍，2-企业队伍，3-社会队伍
        establishedTime: '',
        responsibleAreaId: '',
        responsibleStreetId: '',
        address: '',
        longitude: '',
        dimension: '',
        applicableEventTypes: 1,
        superviseLevel: 1,//1-市级，2-区县级，3-镇街级
        introduce: '',
        remarks: '',
        annex: ''
      },
      ruleValidate: {
        name: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        responsibleUnitId: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        personInCharge: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        personInChargePhone: [
          { required: true, validator: validatePhone, trigger: 'change' }
        ],
        dutyTelephone: [
          { required: true, validator: validatePhone, trigger: 'change' }
        ],
        countPeople: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        teamType: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        establishedTime: [
          { required: true, type: 'date', message: '必填', trigger: 'blur' }
        ],
        responsibleAreaId: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        responsibleStreetId: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        longitude: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        dimension: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        applicableEventTypes: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        superviseLevel: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        introduce: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        remarks: [
          { required: false, message: '必填', trigger: 'blur' }
        ],
        annex: [
          { required: false, message: '必填', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.getAllEvents()
    this.getCountry()
    this.getAllUnit()
    if (this.$route.params.row) {
      this.teamInfo = this.$route.params.row.emergencyTeam
      this.teamInfo.applicableEventTypes = this.teamInfo.applicableEventTypes.toString()
      this.teamInfo.responsibleAreaId = this.teamInfo.responsibleAreaId.toString()
      this.getStreeByCountryId(this.teamInfo.responsibleAreaId)
      this.teamInfo.responsibleStreetId = this.teamInfo.responsibleStreetId.toString()
      this.formValidate = this.teamInfo
    }
  },
  methods: {
    goBack(){
      // 跳转关闭当前页
      this.$store.commit('app/closePage', {
        vm: this,
        fromName: this.$route.name,
        toName: 'emergencyTeam'
      })
    },
    annexSuccess(response, file, fileList) {
      console.log(response, file, fileList)
      this.formValidate.annex = file.response
      this.uploading = false
    },
    annexBeforeUpload() {
      this.uploading = true
    },
    delAnnexFilePath() {
      this.formValidate.annex = ''
    },
    ok() {
      this.formValidate.longitude = this.local[0].point.lat
      this.formValidate.dimension = this.local[0].point.lng
    },
    cancel() {
    },
    handleSearch(str) {
      setTimeout(() => {
        const _this = this
        var options = {
          onSearchComplete: function (res) { //检索完成后的回调函数
            var s = [];
            if (local.getStatus() == BMAP_STATUS_SUCCESS) {
              for (var i = 0; i < res.getCurrentNumPois(); i++) {
                s.push(res.getPoi(i));
              }
              // console.log(s)
              _this.searchList = s
            } else {
              _this.searchList = s
            }
          }
        }
        var local = new _this.BMap.LocalSearch(_this.map, options) //创建LocalSearch构造函数
        local.search(str) //调用search方法，根据检索词str发起检索
      }, 1000)
    },
    getLocal() {
      console.log(this.searchPlace)
      this.local = this.searchList.filter(item => item.title === this.searchPlace && item.type === 0)
      console.log(this.local)
      if (this.local.length > 0) {
        for (var i = 0; i < this.local.length; i++) {
          var lat = this.local[i].point.lat // 经度
          var lng = this.local[i].point.lng // 纬度
          var point = new this.BMap.Point(lng, lat)
          var marker = new this.BMap.Marker(point)
          this.map.addOverlay(marker);
          this.map.centerAndZoom(point, 16)
        }
      }
    },
    initBMap() {
      BMapLoader(this.$mapConfigKey).then(BMap => {
        const map = new BMap.Map('map', { enableMapClick: false })
        this.map = map
        this.BMap = BMap
        map.disableKeyboard() // 禁用键盘操作地图
        map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放
        // 添加中心点和缩放等级，如果不添加，初始化出来页面为白屏
        const point = new BMap.Point(116.36555, 37.44131)
        map.centerAndZoom('德州市', 12)
        // var marker = new BMap.Marker(point)
        // this.Map.addOverlay(marker);
      })
    },
    getAllUnit() {
      this.$http.get('/api/unit/getAll').then(res => {
        // console.log(res)
        this.unitList = res.data.data
        console.log(this.unitList)
      })
    },
    //区县
    getCountry() {
      this.$http.get('/api/getLowerLevelDepts?flag=4').then(res => {
        console.log(res)
        this.countryList = res.data
        if (this.countryList.length === 1) {
          this.formValidate.responsibleAreaId = res.data[0].indexCode
        }
      })
    },
    getStreeByCountryId(value) {
      // this.getStreet(value)
    },
    //根据区县获取街道
    getStreet(id) {
      this.$http.get(`/api/street/${id}`).then(res => {
        console.log(res)
        this.streetList = res.data.data
      })
    },
    //获取事件类型/api/event/getAll
    getAllEvents() {
      this.$http.get('/api/event/getAll').then(res => {
        console.log(res)
        this.eventList = res.data.data
        // this.eventList = this.eventList.Map(item => item.id = Number(item.id))
      })
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.saveLoading = true
          this.$http.post('/api/team/emergencyTeams', this.formValidate).then(res => {
            if (res.status === 200 || res.status === 201) {
              this.$Message.success('新增完成！')
              this.saveLoading = false
              // 跳转关闭当前页
              this.$store.commit('app/closePage', {
                vm: this,
                fromName: this.$route.name,
                toName: 'emergencyTeam'
              })
            } else {
              this.$Message.error(res.data.message)
            }
          })
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    editTeam(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.saveLoading = true
          this.$http.put('/api/team/emergencyTeams', this.formValidate).then(res => {
            if (res.status === 200 || res.status === 201) {
              this.$Message.success('修改完成！')
              this.saveLoading = false
              // 跳转关闭当前页
              this.$store.commit('app/closePage', {
                vm: this,
                fromName: this.$route.name,
                toName: 'emergencyTeam'
              })
            } else {
              this.$Message.error(res.data.message)
            }
          })
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    getLocationByMap() {
      this.modal = true
      this.initBMap()
    },
    getLocation() {
      // BMapLoader('DeMrIzatabf5IUkmHah870RHzfbwm9YW').then(BMap => {
      const _this = this
      _this.BMap = this.BMap
      _this.geolocation = new _this.BMap.Geolocation()
      if (_this.geolocation) {
        // 开启SDK辅助定位，仅当使用环境为移动web混合开发，且开启了定位sdk辅助定位功能后生效
        _this.geolocation.enableSDKLocation()
        // 开始定位
        this.positioning = true
        // 倒计时
        this.positioningInterval = setInterval(() => {
          if (this.countDown === 0) {
            this.countDown = 30
            clearInterval(this.positioningInterval)
          } else {
            this.countDown--
          }
        }, 1000)
        // 位置选项
        const positionOptions = {
          enableHighAccuracy: true, // 要求浏览器获取最佳结果
          timeout: 30, //    超时时间
          maximumAge: 0 // 允许返回指定时间内的缓存结果。如果此值为0，则浏览器将立即获取新定位结果
        }
        // 获取用户位置信息
        _this.geolocation.getCurrentPosition(position => {
          // _this.resetPositioning()
          // 获取定位结果状态码
          const statusCode = _this.geolocation.getStatus()
          let msg = '由于未知错误而无法检索设备的位置' // 提示消息
          let msgType = 'error' // 消息类型
          // 判断结果状态码，为0代表获取成功，读取省市、经纬度
          switch (statusCode) {
            case 0:
              msgType = 'success'
              msg = '获取地理位置定位请求成功'
              if (position) {
                // 数据变量定义
                let lat = 0.0 // 经度
                let lng = 0.0 // 纬度
                let province = '未知' // 经度
                let city = '未知' // 纬度

                // 坐标
                if (position.point) {
                  lat = position.point.lat
                  lng = position.point.lng
                }
                // 位置
                if (position.address) {
                  province = position.address.province
                  city = position.address.city
                }
                _this.formValidate.longitude = lat
                _this.formValidate.dimension = lng
              } else {
                msg = '由于未知错误而无法检索设备的位置'
              }
              break
            case 2:
              msg = '由于未知错误而无法检索设备的位置'
              break
            case 4:
            case 5:
              msg = '位置服务请求非法'
              break
            case 6:
              msg = '应用程序没有使用位置服务的权限'
              break
            case 7:
              msg = '网络不可用或者无法连接到获取位置信息的卫星'
              break
            case 8:
              msg = '无法在指定的最大超时间隔内检索位置信息'
              break
            default:
              msg = '由于未知错误而无法检索设备的位置'
              break
          }
          _this.$Message.info(msg)
        }, positionOptions)
      } else {
        _this.$notification.error({
          key: NotificationKey,
          message: '提示',
          description: '您的浏览器不支持地理位置服务'
        })
      }
      // })
    }
  }
}
</script>

<style scoped lang="less">
.add-team {
}
</style>
